export type SkinBreakpointKey = "phone" | "tablet" | "laptop" | "desktop" | "xl";

export const VIEWPORT_PRESETS: Array<{ key: SkinBreakpointKey; label: string; width: number }> = [
  { key: "phone", label: "Phone", width: 390 },
  { key: "tablet", label: "Tablet", width: 768 },
  { key: "laptop", label: "Laptop", width: 1280 },
  { key: "desktop", label: "Desktop", width: 1440 },
  { key: "xl", label: "XL", width: 1920 },
];
